import { ACTION_TYPES } from './actionTypes'

export const creditListAction = (payload) => ({
	type: ACTION_TYPES.CREDIT_LIST,
	payload,
})
